import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import { Button, Popup, Radio } from 'next-common-lib';
import i18n from 'i18n';
import TextFieldFormik from 'components/Common/InputBox';
import TblList from 'components/Common/Template/TblList';
import TblCell from 'components/Common/Template/TblCell';
import ProgressPopup from 'components/Common/Popup/ProgressPopup';
import * as popupActions from 'redux/ducks/common/popupDucks';
import * as wizardActions from 'redux/ducks/common/wizardDuck';
import * as gnbMenuActions from 'redux/ducks/GnbMenu/GnbMenuDucks';
import { GnbMenuSchema } from './GnbMenuSchema';

export const PopupGnbMenu = ({ pageList, setPageList }) => {
  const dispatch = useDispatch();
  const gnbPopup = useSelector(state => state.wizard.gnbPopup);
  const isShowProgressPopup = useSelector(state => state.popup.ProgressPopup.isShow);
  const menu = useSelector(state => state.menu);
  const adminVo = useSelector(state => state.adminInfo.adminVo);
  const [count, setCount] = useState(1000);

  let handleOnClose = () => {};

  const formik = useFormik({
    initialValues: { titleKo: '', titleEn: '', urlParameter: '', target: 'NW' },
    validationSchema: GnbMenuSchema,
    onSubmit: values => {
      const payload = {
        titleKo: values.titleKo,
        titleEn: values.titleEn,
        popUpTarget: values.target,
        url: values.urlParameter,
        urlType: 'O',
        activeYn: 'Y',
        currentCompId: adminVo.compCd,
        servicedLanguages: ['ko', 'en', 'ja', 'zh'],
        servicedNetworks: ['EX', 'IN'],
        servicedLocales: ['KR', 'GB', 'US'],
        servicedBrowsers: ['IE', 'ETC'],
      };
      if (gnbPopup.name === 'GNBPAGELIST') {
        setCount(count + 1);
        payload.currentCompId = 'GROUP';
        payload.pageTheme = 'URL';
        payload.fxdBrwsUseYn = 'N';
        payload.layoutId = 20000;
        payload.count = count;
        setPageList([...pageList, payload]);
        handleOnClose();
      } else {
        payload.currentCompId = adminVo.compCd;
        payload.menuType = 'EXEC';
        dispatch(gnbMenuActions.createGnbMenu(payload));
        dispatch(popupActions.openProgressPopup());
      }
    },
  });

  handleOnClose = () => {
    formik.handleReset();
    dispatch(wizardActions.closeGnbPopup());
    dispatch(popupActions.closeProgressPopup());
    if (gnbPopup.name === 'GNBPAGELIST') {
      dispatch(wizardActions.openPopup());
    }
  };

  useEffect(() => {
    if (menu.isSuccess) {
      dispatch(popupActions.closeProgressPopup());
      dispatch(wizardActions.closeGnbPopup());
      formik.handleReset();
    }
  }, [menu.isSuccess]);

  return (
    <>
      {gnbPopup.isPopup && (
        <Popup
          id="GnbMenuPopup"
          isShow={gnbPopup.isPopup}
          isDimed={gnbPopup.isPopup}
          dimedClassName="transparent"
          isDimedOverlap
          zIndex={2500}
          size="sm w-popup"
          componentType="normalPopup"
          useScroll={false}
          closeFunction={() => {
            handleOnClose();
          }}
          headerComponent={[
            <h1 className="popup-title" key={1}>
              {gnbPopup.name === 'GNBPAGELIST'
                ? `${i18n.t('BTY_W_T_CREATE_MENU')}`
                : `${i18n.t('BTY_W_T_CREATE_MENU_GENERAL')}`}
            </h1>,
          ]}
          contentsComponent={[
            <div className="article-body">
              <TblList>
                <TblCell isHeader>{i18n.t('BTY_W_T_TITLE_KO')}</TblCell>
                <TblCell>
                  <TextFieldFormik
                    id="titleKo"
                    formik={formik}
                    placeholderLabel={i18n.t('BTY_W_T_TITLE_KO_INFO')}
                    maxLength={30}
                    useExpLabel={formik.errors.titleKo !== undefined}
                    autoFocus
                  />
                </TblCell>
              </TblList>
              <TblList>
                <TblCell isHeader>{i18n.t('BTY_W_T_TITLE_EN')}</TblCell>
                <TblCell>
                  <TextFieldFormik
                    id="titleEn"
                    formik={formik}
                    placeholderLabel={i18n.t('BTY_W_T_TITLE_EN_INFO')}
                    maxLength={30}
                    useExpLabel={formik.errors.titleEn !== undefined}
                  />
                </TblCell>
              </TblList>
              <TblList>
                <TblCell isHeader>URL</TblCell>
                <TblCell>
                  <TextFieldFormik
                    id="urlParameter"
                    formik={formik}
                    placeholderLabel={i18n.t('BTY_W_T_ADD_URL')}
                    maxLength={30}
                    useExpLabel={formik.errors.urlParameter !== undefined}
                  />
                </TblCell>
              </TblList>
              <TblList>
                <TblCell isHeader>{i18n.t('PT_ADMIN_COMMON_ATTRIBUTE')}</TblCell>
                <TblCell>
                  <Radio
                    checked={formik.getFieldProps('target').value === 'NW'}
                    id="goTarget"
                    label={i18n.t('PT_COMMON_NEWWINDOW')}
                    name="targetRaioBtn"
                    componentType="normal"
                    tooltipInfo={{
                      title: `${i18n.t('PT_COMMON_NEWWINDOW')}`,
                    }}
                    onChange={e => {
                      formik.setFieldValue('target', e.target.value);
                    }}
                    value="NW"
                  />
                  <Radio
                    checked={formik.getFieldProps('target') === 'NB'}
                    id="goTargetNb"
                    label={i18n.t('PT_COMMON_NEWTAP')}
                    componentType="normal"
                    name="targetRaioBtn"
                    tooltipInfo={{
                      title: `${i18n.t('PT_COMMON_NEWTAP')}`,
                    }}
                    value="NB"
                    onChange={e => {
                      formik.setFieldValue('target', e.target.value);
                    }}
                  />
                </TblCell>
              </TblList>
            </div>,
          ]}
          bottomComponent={[
            <div className="btn-set al-right">
              <div className="btn-group">
                <Button
                  componentType="solid"
                  className="secondary"
                  size="md"
                  label={i18n.t('EM_T_CANCEL')}
                  onClick={() => {
                    handleOnClose();
                  }}
                />
                <Button
                  componentType="solid"
                  className="primary"
                  size="md"
                  label={i18n.t('EM_T_SAVE')}
                  disabled={isShowProgressPopup}
                  onClick={() => {
                    formik.submitForm();
                  }}
                />
              </div>
            </div>,
          ]}
        />
      )}
      {isShowProgressPopup && <ProgressPopup />}
    </>
  );
};
PopupGnbMenu.propTypes = {
  setPageList: PropTypes.func,
  pageList: PropTypes.arrayOf(PropTypes.object),
};
PopupGnbMenu.defaultProps = { setPageList: () => {}, pageList: [] };
export default PopupGnbMenu;
